// extracted by mini-css-extract-plugin
export default {"container":"xt-z","title":"yt-z","linkContainer":"zt-z","viewItemLink":"At-z"};